import apiClient from './api/client'
import type { SeekerProfile } from '../types/seeker'

export interface SeekerProfileUpdateData extends Partial<SeekerProfile> {
  first_name?: string
  last_name?: string
  email?: string
}

export const seekerService = {
  // Get current user's seeker profile
  async getMyProfile(): Promise<SeekerProfile> {
    const { data } = await apiClient.get('/seekers/profiles/me/')
    return data
  },

  // Update current user's seeker profile
  async updateMyProfile(profileData: SeekerProfileUpdateData): Promise<SeekerProfile> {
    const { data } = await apiClient.patch('/seekers/profiles/me/', profileData)
    return data
  },

  // Get a seeker profile by ID
  async getSeeker(id: string): Promise<SeekerProfile> {
    const { data } = await apiClient.get(`/seekers/profiles/${id}/`)
    return data
  },
}

export default seekerService
